function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.359619,
  width: 58.657,
  height: 57,
  rx: 8,
  fill: "#87C5FF",
  fillOpacity: 0.2
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M39.6582 21.3669C39.9906 19.261 39.6582 17.857 38.4948 16.561C37.2207 15.1031 34.8939 14.5091 31.9024 14.5091H23.3157C22.7063 14.5091 22.2077 14.9411 22.0969 15.5351L18.496 37.6746C18.4406 38.1066 18.773 38.4846 19.2162 38.4846H24.5345L24.1467 40.7526C24.0913 41.1305 24.3683 41.4545 24.8114 41.4545H29.2987C29.8527 41.4545 30.2959 41.0765 30.3513 40.5906L31.2931 34.8667C31.3485 34.3807 31.847 34.0027 32.3456 34.0027H33.0104C37.3315 34.0027 40.7662 32.2747 41.7633 27.3068C42.1511 25.2549 41.9849 23.4729 40.877 22.2849C40.5446 21.9069 40.1568 21.6369 39.6582 21.3669Z",
  fill: "white",
  fillOpacity: 0.3
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M39.6582 21.3669C39.9906 19.261 39.6582 17.857 38.4948 16.561C37.2207 15.1031 34.8939 14.5091 31.9024 14.5091H23.3157C22.7063 14.5091 22.2077 14.9411 22.0969 15.5351L18.496 37.6746C18.4406 38.1066 18.773 38.4846 19.2162 38.4846H24.5345L25.8086 30.4928C25.9194 29.8988 26.418 29.4668 27.0274 29.4668H29.5757C34.5616 29.4668 38.4394 27.5228 39.5474 21.7989C39.6028 21.6909 39.6028 21.5289 39.6582 21.3669Z",
  fill: "white",
  fillOpacity: 0.29
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M27.3044 21.4209C27.3598 21.043 27.8584 20.557 28.3569 20.557H35.1155C35.8911 20.557 36.6667 20.611 37.3315 20.719C37.9409 20.827 39.0488 21.097 39.6028 21.4209C39.9352 19.315 39.6028 17.911 38.4394 16.615C37.2207 15.1031 34.8939 14.5091 31.9024 14.5091H23.3157C22.7063 14.5091 22.2077 14.9411 22.0969 15.5351L18.496 37.6746C18.4406 38.1066 18.773 38.4846 19.2162 38.4846H24.5345L27.3044 21.4209Z",
  fill: "white"
});

function SvgPension(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 57,
    viewBox: "0 0 60 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPension);
export default __webpack_public_path__ + "static/media/pension.dfdcf374.svg";
export { ForwardRef as ReactComponent };